export default `float de(vec3 p){  
    vec2 p0 = p.xy;    
    vec2 bd = vec2(1.); 
    vec2 d = abs(p0) - bd;

    return max(d.x, d.y);
  }

  float de(vec3 p){
    vec2 p0 = p.xy;    
    vec2 bd = vec2(1.); 
    vec2 d = abs(p0) - bd;
    vec2 md = min(d, vec2(0.));

    return length(max(d, vec2(0.0))) + max(max(md.x, md.y), md.z);
  }`